/* eslint-disable */
export default {
  ringing: 'Appel entrant',
  callConnected: 'Appel établi',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
